import { createSlice } from '@reduxjs/toolkit';

const cookieConsentSlice = createSlice({
  name: 'cookieConsent',
  initialState: {
    isVisible: false,
  },
  reducers: {
    setCookieConsentVisible: (state, action) => {
      state.isVisible = action.payload;
    },
  },
});

export const { setCookieConsentVisible } = cookieConsentSlice.actions;

export const selectCookieConsentVisible = (state: any) => state.cookieConsent.isVisible;

export default cookieConsentSlice.reducer;
